import { forwardRef } from "react";
import { isNil } from "lodash";
import { NumberField } from "./NumberField";
import type { YearFieldProps } from "./types";
import style from "./YearField.module.scss";

export const ALLOWED_NUMBER_INPUT_KEYS = new Set([
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Enter",
    "Tab",
]);

export const YearField = forwardRef<HTMLInputElement, YearFieldProps>(function YearField(
    { id, placeholder, ariaLabel, value, onChange, required, customValidation, ...rest },
    ref,
) {
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
        if (!ALLOWED_NUMBER_INPUT_KEYS.has(event.key)) {
            event.preventDefault();
        }
    };
    return (
        <NumberField
            id={id}
            ref={ref}
            ariaLabel={ariaLabel}
            required={required}
            placeholder={placeholder}
            onKeyDown={handleKeyDown}
            onChange={({ target }) => onChange(target.value ? Number(target.value) : null)}
            value={isNil(value) ? "" : String(value)}
            className={style.yearField}
            validationPattern="year"
            customValidation={customValidation}
            {...rest}
        />
    );
});
